import { GoatAwkward, useIntl } from '@capsicum/common';
import { GenericDrawer, Text } from '@capsicum/common-web';
import styled from 'styled-components';

type NCWalletRecoverySuccessDrawerProps = {
	closeModal: () => void;
};

/*
 * This success drawer is shown when recover-wallet succeeds; in front of the new Recovery Kit download UI
 */
export const NCWalletRecoverySuccessDrawer = ({ closeModal }: NCWalletRecoverySuccessDrawerProps) => {
	const { $t } = useIntl();
	const intlText = {
		buttonText: $t('ncOnboarding.recoveryKit.recoverWallet.successDrawer.buttonText'),
		paragraph1: $t('ncOnboarding.recoveryKit.recoverWallet.successDrawer.paragraph1'),
		paragraph2: $t('ncOnboarding.recoveryKit.recoverWallet.successDrawer.paragraph2'),
		paragraph3: $t('ncOnboarding.recoveryKit.recoverWallet.successDrawer.paragraph3'),
		title: $t('ncOnboarding.recoveryKit.recoverWallet.successDrawer.title')
	};

	return (
		<GenericDrawer
			buttonText={intlText.buttonText}
			image={GoatAwkward}
			testID="ncw-recoverWallet-success-drawer"
			onButtonPress={closeModal}
		>
			<S.ChildrenWrapper>
				<Text variant="title6">{intlText.title}</Text>
				<S.Paragraph1And2 variant="text3">{intlText.paragraph1}</S.Paragraph1And2>
				<S.Paragraph1And2 variant="text3">{intlText.paragraph2}</S.Paragraph1And2>
				<Text color="destructive.enabled" variant="text3">
					{intlText.paragraph3}
				</Text>
			</S.ChildrenWrapper>
		</GenericDrawer>
	);
};

namespace S {
	export const ChildrenWrapper = styled.div`
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxxxsmall};
		margin-top: ${({ theme }) => theme.spacings.large};
	`;

	export const Paragraph1And2 = styled(Text)`
		text-align: center;
		margin-top: ${({ theme }) => theme.spacings.small};
	`;
}
